import { ArrowUpRight, Linkedin, UserRound } from "lucide-react";
import { BRAND } from "@/data/content";
import SectionBadge from "@/components/site/SectionBadge";

const HIGHLIGHTS = [
  "MBA — IIM Indore",
  "16+ years across Marketing, Brand & Category Management, Corporate Strategy, Management Consulting, P&L Management, Digital Marketing, E-commerce Sales, Market Research, GTM Strategy, and Campaign Management.",
  "5+ years in leadership roles with an exceptional P&L management track record — turned around 3 businesses into profitable ones with accelerated sales growth.",
  "Led high-impact, high-visibility business transformation programs at Fortune 500 MNCs with teams across US, UK, UAE, Saudi Arabia, Oman, Qatar, Germany, Australia & Philippines, Indian public-listed companies, and mid & early-stage start-ups in India.",
];

export default function Leadership({ onBook }) {
  return (
    <section
      id="leadership"
      data-testid="leadership-section"
      className="pt-16 md:pt-20 pb-24 md:pb-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <SectionBadge label="Leadership" />
        <div className="mt-6 grid grid-cols-12 gap-6 md:gap-10">
        {/* Portrait */}
        <div className="col-span-12 md:col-span-5 relative">
          <div className="relative aspect-[4/5] w-full overflow-hidden bg-zinc-100 border border-zinc-200">
            <img
              data-testid="leadership-portrait"
              src={BRAND.ceoPhoto}
              alt="Khalid Kamal Rumi — Founder & CEO, BLEZZINGS"
              className="absolute inset-0 w-full h-full object-cover object-center slow-scale"
            />
          </div>
          <div className="hidden md:block absolute -z-10 -left-6 top-16 w-32 h-32 border border-black" aria-hidden />
        </div>

        {/* Bio */}
        <div className="col-span-12 md:col-span-7 md:pl-4">
          <h1 className="font-serif-display text-4xl sm:text-5xl mt-2 leading-[1.05]">
            Khalid Kamal Rumi
          </h1>
          <div className="mt-2 text-zinc-500 text-sm tracking-wide">
            Founder &amp; Chief Executive Officer
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <a
              data-testid="leadership-linkedin"
              href={BRAND.contact.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 border border-zinc-300 text-sm font-medium text-black hover:bg-black hover:text-white transition-colors duration-300"
            >
              <Linkedin className="h-4 w-4" />
              LinkedIn
            </a>
            <button
              data-testid="leadership-book-btn"
              onClick={onBook}
              className="inline-flex items-center justify-center gap-2 h-12 px-6 bg-black text-white text-sm font-medium hover:bg-black transition-colors duration-300"
            >
              Book a Consultation
              <ArrowUpRight className="h-4 w-4" />
            </button>
          </div>

          <ul className="mt-10 space-y-6">
            {HIGHLIGHTS.map((h, i) => (
              <li
                key={i}
                className="grid grid-cols-[auto_1fr] gap-5 items-baseline border-b border-zinc-200 pb-6"
                data-testid={`leadership-highlight-${i}`}
              >
                <div className="font-serif-display text-2xl text-black tabular">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <p className="text-[15px] text-zinc-700 leading-relaxed">{h}</p>
              </li>
            ))}
          </ul>
        </div>
        </div>
      </div>
    </section>
  );
}
